module.exports = __webpack_public_path__ + "static/media/Tyson Bat.87979920.jpg";